/**
 * 解析URL传参
 * @param {Object} key
 */
 export function getQueryVariable(key: string) {
    let after = window.location.search !== '' ? window.location.search : window.location.hash;
    if (after.indexOf('?') === -1) return null; //如果url中没有传参直接返回空
  
    //key存在先通过search取值如果取不到就通过hash来取
    after = after.substr(after.indexOf('?') + 1) || window.location.hash.split('?')[1];
  
    if (after) {
      let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
      let r = after.match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      } else {
        return null;
      }
    }
  }
  export const deleteSearch = () => {
    let path = window.location.href.split('?')[0];
    window.location.href = path;
  };